import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {set} from '../../../Utils/Crypto';

const LANGUAGES = [
	{name: 'English', code: 'en'},
	{name: 'العربية', code: 'ar'},
	{name: 'हिन्दी', code: 'hi'},
	{name: '简体中文', code: 'zh-Hans'},
	{name: 'Deutsch', code: 'de'},
	{name: '日本語', code: 'ja'},
	{name: '한국어', code: 'ko'},
	{name: 'Türkçe', code: 'tr'},
	{name: 'Français', code: 'fr'},
	{name: 'Español', code: 'es'},
]

function LanguageSwitcher({style}) {
	const {t, i18n} = useTranslation()
	const [open, setOpen] = useState(false)
	const containerRef = useRef(null)

	useEffect(() => {
		const handleOutsideClick = (event) => {
			if (containerRef.current && !containerRef.current.contains(event.target)) {
				setOpen(false)
			}
		}
		document.addEventListener('mousedown', handleOutsideClick)
		return () => document.removeEventListener('mousedown', handleOutsideClick)
	}, [])

	const currentLanguage = LANGUAGES.find(lang => lang.code === i18n.language) || LANGUAGES[0]

	const handleSelect = (code) => {
		i18n.changeLanguage(code)
		set('lang', code)
		setOpen(false)
	}

	return (
		<div ref={containerRef} style={{position: 'relative', ...style}}>
			<div
				onClick={() => setOpen(!open)}
				title={t('Switch Language')}
				style={{
					cursor: 'pointer',
					display: 'flex',
					alignItems: 'center',
					gap: 8,
					padding: '9px 16px',
					borderRadius: 20,
					background: '#fff',
					border: '1px solid #E5E8EC',
					fontSize: 13,
					fontWeight: 500,
					color: '#333',
					whiteSpace: 'nowrap',
				}}
			>
				<i className="fa-solid fa-earth-americas"></i>
				{t('Switch Language')}
			</div>
			{
				open ?
					<div style={{
						position: 'absolute',
						top: 46,
						right: 0,
						background: '#fff',
						border: '1px solid #E5E8EC',
						borderRadius: 8,
						boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
						minWidth: 160,
						maxHeight: 280,
						overflowY: 'auto',
						zIndex: 30,
					}}>
						{
							LANGUAGES.map(lang => (
								<div
									key={lang.code}
									onClick={() => handleSelect(lang.code)}
									style={{
										padding: '10px 16px',
										cursor: 'pointer',
										fontSize: 13,
										fontWeight: lang.code === currentLanguage.code ? 600 : 400,
										color: lang.code === currentLanguage.code ? 'var(--active-color, #028467)' : '#333',
										background: lang.code === currentLanguage.code ? 'rgba(0,0,0,0.04)' : 'transparent',
									}}
									onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(0,0,0,0.06)'}
									onMouseLeave={(e) => e.currentTarget.style.background = lang.code === currentLanguage.code ? 'rgba(0,0,0,0.04)' : 'transparent'}
								>
									{lang.name}
								</div>
							))
						}
					</div>
					: null
			}
		</div>
	)
}

export default LanguageSwitcher;
